import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function VerifyIcon({ className, width = 24, height = 25 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 24 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M21.5599 11.2401L20.1999 9.66006C19.9399 9.36006 19.7299 8.80006 19.7299 8.40006V6.70006C19.7299 5.64006 18.8599 4.77006 17.7999 4.77006H16.0999C15.7099 4.77006 15.1399 4.56006 14.8399 4.30006L13.2599 2.94006C12.5699 2.35006 11.4399 2.35006 10.7399 2.94006L9.16988 4.31006C8.86988 4.56006 8.29988 4.77006 7.90988 4.77006H6.17988C5.11988 4.77006 4.24988 5.64006 4.24988 6.70006V8.41006C4.24988 8.80006 4.03988 9.36006 3.78988 9.66006L2.43988 11.2501C1.85988 11.9401 1.85988 13.0601 2.43988 13.7501L3.78988 15.3401C4.03988 15.6401 4.24988 16.2001 4.24988 16.5901V18.3001C4.24988 19.3601 5.11988 20.2301 6.17988 20.2301H7.90988C8.29988 20.2301 8.86988 20.4401 9.16988 20.7001L10.7499 22.0601C11.4399 22.6501 12.5699 22.6501 13.2699 22.0601L14.8499 20.7001C15.1499 20.4401 15.7099 20.2301 16.1099 20.2301H17.8099C18.8699 20.2301 19.7399 19.3601 19.7399 18.3001V16.6001C19.7399 16.2101 19.9499 15.6401 20.2099 15.3401L21.5699 13.7601C22.1499 13.0701 22.1499 11.9301 21.5599 11.2401ZM16.1599 10.6101L11.3299 15.4401C11.1899 15.5801 10.9999 15.6601 10.7999 15.6601C10.5999 15.6601 10.4099 15.5801 10.2699 15.4401L7.84988 13.0201C7.55988 12.7301 7.55988 12.2501 7.84988 11.9601C8.13988 11.6701 8.61988 11.6701 8.90988 11.9601L10.7999 13.8501L15.0999 9.55006C15.3899 9.26006 15.8699 9.26006 16.1599 9.55006C16.4499 9.84006 16.4499 10.3201 16.1599 10.6101Z'
                fill='#6262BE'
            />
        </svg>
    );
}

export default VerifyIcon;

